export default "__VITE_ASSET__CW9d7d$$__"